import React from 'react';
import ValidatedInput from '../TextInput/ValidatedInput';
import './passwordinput.scss';
import see from '../../../assets/images/see.svg';
import hide from '../../../assets/images/unsee.svg';
import hideEye from '../../../assets/images/hideEye.png';
import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';

/** @import { PasswordInputProps, PasswordInputState } from './PasswordInputTypes' */

/** @extends ValidatedInput<PasswordInputProps> */
class PasswordInput extends ValidatedInput {
    /** @type {PasswordInputState} */
    state = { value: '', showing: false };

    toggleSee() {
        this.setState({ showing: !this.state.showing });
    }

    render() {
        return (
            <div className="password-input login__input">
                <input
                    name={this.props.name}
                    className={this.getInputClassNames()}
                    type={this.state.showing ? 'text' : 'password'}
                    placeholder={this.props.placeholder}
                    onChange={this.handleOnChange}
                    disabled={this.props.disabled}
                    ref={this.props.inputRef}
                    data-test={this.props.name}
                />

                <div className="password-input__showhide" onClick={() => this.toggleSee()}>
                    <img style={{ width: '24px', height: '24px' }}
                        alt="toggle password visibility"
                        className={this.state.showing ? 'password-input__showhide--showing' : ''}
                        src={this.state.showing ? hideEye : see}
                    />
                </div>

                {this.renderValidations()}
            </div>
        );
    }
}

export default withFeatureFlags(PasswordInput);